export const buildUpgradeRecommendationRequestBody = _ref => {
  var _currentSubscription$;
  let {
    currentSubscription,
    saleType
  } = _ref;
  const subscriptionId = currentSubscription == null ? void 0 : currentSubscription.subscriptionId;
  const currentProductFamilyId = currentSubscription == null ? void 0 : currentSubscription.productFamilyId;
  if (!subscriptionId || !currentProductFamilyId) {
    return undefined;
  }
  const periodEndDate = currentSubscription == null ? void 0 : currentSubscription.periodEndDate;
  return {
    subscriptionId,
    currentProductFamilyId,
    currentCycle: currentSubscription == null || (_currentSubscription$ = currentSubscription.cycle) == null ? void 0 : _currentSubscription$.cycleDuration,
    periodEndDate: periodEndDate ? new Date(periodEndDate).toISOString() : undefined,
    saleType
  };
};
//# sourceMappingURL=build-upgrade-recommendation-request-body.js.map